module.exports = __webpack_public_path__ + "static/media/400118_02.2d2f5e99.png";